import { useSelector } from 'react-redux';

import selectorUser from '@redux/user/selectors';
import { useCheckPermissions } from 'hooks/useCheckPermissions';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

import { useUserInfo } from 'hooks/auth/useUserInfo';

const useCheckDisableWithdrawPublicationModal = (productData) => {
  const {
    userInfo
  } = useUserInfo();
  const hasPermissionManageSyndication = useCheckPermissions([
    {
      action: ABILITY_ACTION.MAINTAIN,
      subject: ABILITY_SUBJECT.SYNDICATION,
    },
  ]);

  const isNotOwner = !productData?.isOwner;
  const isNotSyndication = !productData?.syndication;

  if (!productData) return true;

  if (!userInfo?.isRivirGdsnParty) return true;

  /**
   * vktin - #8952: new condition to active withdraw button
        User has Manage_Syndication permission
        Product.Syndication = true
        Product.isOwner = true. 
   * Created: 2024-11-18
   */

  if (isNotOwner || isNotSyndication || !hasPermissionManageSyndication) {
    return true;
  }

  return false;
};

export { useCheckDisableWithdrawPublicationModal };
